// src/components/Login/ConfirmationEmailSent.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/damelio_logo_blanco.png';
import logo2 from '../../assets/damelio_texto_blanco.png';

interface ConfirmationEmailSentProps {
  onGoLogin: () => void;
}

const ConfirmationEmailSent: React.FC<ConfirmationEmailSentProps> = ({ onGoLogin }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <img
        src={logo}
        alt={t('login.altLogo')}
        className="mx-auto h-32 w-auto transition-transform duration-300"
      />
      <img
        src={logo2}
        alt={t('login.altLogo2')}
        className="mx-auto h-20 w-auto mt-2 transition-transform duration-300"
      />

      <h2 className="text-2xl font-bold text-center text-white">
        {t('register.confirmation.title')}
      </h2>

      <p className="text-center text-gray-300">
        {t('register.confirmation.message')}
      </p>

      <div className="text-center">
        <button
          onClick={onGoLogin}
          className="
            bg-gradient-to-r from-blue-500 to-indigo-600 
            hover:from-blue-600 hover:to-indigo-700 
            text-white font-semibold 
            px-5 py-3 rounded-lg 
            shadow-lg shadow-indigo-900/50 
            transition-transform transform hover:scale-105
          "
        >
          {t('register.confirmation.goLogin')}
        </button>
      </div>

      <p className="text-center text-sm text-gray-400">
        {t('register.confirmation.checkSpam')}
      </p>
    </div>
  );
};

export default ConfirmationEmailSent;
